import React from 'react'
import styled from 'styled-components'
import { CLIENT_SETTINGS } from 'constants/clientSettings'
import { PageMessage } from 'constants/pageMessage'
import { Frame, FrameStyle } from '../Frame'
import Text from '../texts/Text'

/** Frameコンポーネントのスタイル定義 */
const frameStyle: FrameStyle = {
  background: '#ffffff',
  border: '2px solid var(--color-text)',
}

/** ご注意事項の見出しのスタイル */
const CautionTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  color: #ffffff;
  font-weight: bold;
  text-align: center;
  background-color: var(--color-icon-partner);
`

/** ご注意事項の本文のスタイル */
const CautionText = styled.li`
  font-weight: bold;
`

/** ドメインごとの注意事項を表示するコンポーネント */
const Precautions: React.FC = () => {
  /** クライアントごとのご注意事項メッセージ */
  const cautionMessages: string[] = CLIENT_SETTINGS.messages.precautions

  return (
    <>
      <CautionTitle>{PageMessage['precautions.title']}</CautionTitle>
      <Frame {...frameStyle}>
        <Text bold>{PageMessage['precautions.caption']}</Text>
        <ul style={{ margin: '0' }}>
          {cautionMessages.map((message, i) => (
            <CautionText key={i}>
              <Text>{message}</Text>
            </CautionText>
          ))}
        </ul>
      </Frame>
    </>
  )
}

export default React.memo(Precautions)
